import React from "react";
import { Row, Col, Form, Select, Input, Button, DatePicker } from "antd";
import { SPLIT_TYPE_OPTIONS } from "@/constants/util"

const DATE_FORMAT='YYYY-MM-DD';

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

const Option = Select.Option;

const Search = (props) => {
  const {
    form,
    onSearch=()=>{}
  } = props;

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) { 
        if(values.time && Array.isArray(values.time)){ 
          values.beginTime=values.time?.[0]?.format(DATE_FORMAT);
          values.endTime=values.time?.[1]?.format(DATE_FORMAT);
          delete values.time;
        }
        onSearch(values) 
      }
    })
  };

  return (
    <div className="pl-24 pr-24 bg-white pt-16 pb-16 bd-line mt-16">
      <Row>
        <Col span={20}>
          <Form layout="inline" > 
             <Form.Item>
              {form.getFieldDecorator("capsuleNo", {})(
                <Input  style={{width:180}} placeholder="设备编号" /> 
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSubmit}>
                搜索
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default Form.create()(Search);
